import { useState } from "react";
import { Menu, X, Phone, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_0808c772-0b84-4caf-af02-d4cf76d8b0d8/artifacts/49nqn57a_CloudJet_Clean_Transparent.png";

const navLinks = [
  { name: "Home", href: "#home" },
  { name: "About", href: "#about" },
  { name: "Services", href: "#services" },
  { name: "Destinations", href: "#destinations" },
  { name: "Contact", href: "#contact" },
];

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-sky-200" data-testid="header">
      {/* Top bar */}
      <div className="bg-sky-600 text-white py-2 px-4">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center text-sm gap-2">
          <div className="flex items-center gap-4">
            <a href="tel:+61295387640" className="flex items-center gap-1 hover:text-sky-200 transition-colors" data-testid="phone-link">
              <Phone size={14} />
              <span>+61 2 9538 7640</span>
            </a>
            <a href="mailto:hello@cloudjet.com.au" className="flex items-center gap-1 hover:text-sky-200 transition-colors" data-testid="email-link">
              <Mail size={14} />
              <span>hello@cloudjet.com.au</span>
            </a>
          </div>
          <span className="text-sky-100">Sydney, NSW Australia</span>
        </div>
      </div>

      {/* Main navigation */}
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <a href="#home" onClick={() => scrollToSection("#home")} className="flex-shrink-0" data-testid="logo-link">
            <img 
              src={LOGO_URL} 
              alt="CloudJet - Travel Made Easy" 
              className="h-16 w-auto"
              data-testid="logo-image"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => scrollToSection(link.href)}
                className="text-sky-800 hover:text-sky-600 font-medium transition-colors"
                data-testid={`nav-${link.name.toLowerCase()}`}
              >
                {link.name}
              </button>
            ))}
            <Button 
              onClick={() => scrollToSection("#contact")}
              className="bg-sky-600 hover:bg-sky-700 text-white"
              data-testid="nav-get-quote-btn"
            >
              Get a Quote
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2 text-sky-800"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-sky-100" data-testid="mobile-menu">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <button
                  key={link.name}
                  onClick={() => scrollToSection(link.href)}
                  className="text-sky-800 hover:text-sky-600 font-medium text-left py-2"
                  data-testid={`mobile-nav-${link.name.toLowerCase()}`}
                >
                  {link.name}
                </button>
              ))}
              <Button 
                onClick={() => scrollToSection("#contact")}
                className="bg-sky-600 hover:bg-sky-700 text-white w-full"
                data-testid="mobile-get-quote-btn"
              >
                Get a Quote
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
